module.exports = __webpack_public_path__ + "static/media/Tornax-RT-2100.e5addaaf.png";